import React, { useState } from "react";

import { useToasts } from "react-toast-notifications";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { CustomMetricsNewBadge } from "@features/custom-metrics/custom-metrics-modal";
import { useCustomMetricsContext } from "@features/custom-metrics/hooks/custom-metrics-provider";
import { useOverviewContext } from "@features/overview-v2/hooks";
import { EllipsisMenu } from "@features/shared";
import { useFeatureFlags } from "@hooks/http";
import { useDisclosure } from "@hooks/use-disclosure";

import { CreateSavedViewModal } from "../../modals";

import { ConfigurationModal } from "./configuration-modal";
import { NewOverviewExperienceSwitch } from "./new-overview-experience-switch";

export const ConfigurationMenu = () => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const { createEmptySavedView } = useOverviewContext();
  const [isCreatingSavedView, setIsCreatingSavedView] = useState(false);
  const { openModal: openCustomMetricsModal } = useCustomMetricsContext();
  const toasts = useToasts();
  const { hasFeatureFlag } = useFeatureFlags();
  const [modalOpened, { open: openModal, close: closeModal }] = useDisclosure(
    false,
    {
      onChange: ({ state }) =>
        prettyLogEventPage({
          domain: "Configuration Menu",
          action: { opened: "onClick" as const, closed: "onClose" as const }[
            state
          ],
          additionalActionInfo: {
            opened: "Open Configuration Modal",
            closed: "Close Configuration Modal",
          }[state],
        }),
    },
  );
  return (
    <>
      <EllipsisMenu>
        <EllipsisMenu.Item
          as="button"
          onClick={() => setIsCreatingSavedView(true)}
        >
          Create new
        </EllipsisMenu.Item>
        <EllipsisMenu.Item as="button" onClick={() => openModal()}>
          Configuration details
        </EllipsisMenu.Item>
        {hasFeatureFlag("customMetricsForOverviewPage") && (
          <EllipsisMenu.Item as="button" onClick={openCustomMetricsModal}>
            Custom metrics
            <CustomMetricsNewBadge className="ml-2" />
          </EllipsisMenu.Item>
        )}
        <EllipsisMenu.Item
          as="button"
          className="cursor-default"
          onClick={() => {
            // Do nothing
          }}
        >
          <NewOverviewExperienceSwitch switchClassname="ml-auto" basic />
        </EllipsisMenu.Item>
      </EllipsisMenu>
      <ConfigurationModal isOpen={modalOpened} onClose={() => closeModal()} />
      <CreateSavedViewModal
        isOpen={isCreatingSavedView}
        title="Create empty layout"
        onClose={() => setIsCreatingSavedView(false)}
        onSubmit={(name: string) =>
          createEmptySavedView(name, {
            errorMessage: "There was an error creating the view.",
            onSuccess: () => {
              setIsCreatingSavedView(false);
              toasts.addToast("Saved view created", {
                appearance: "success",
              });
            },
          })
        }
      />
    </>
  );
};
